import ClothSystem from './ClothSystem.vue';

export default ClothSystem;
